export const EditIcon = ({ height = 24, width = 25 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.2652 6.12109L5.05522 14.8111C4.74522 15.1411 4.44522 15.7911 4.38522 16.2411L4.01522 19.4811C3.88522 20.6511 4.72522 21.4511 5.88522 21.2511L9.10522 20.7011C9.55522 20.6211 10.1852 20.2911 10.4952 19.9511L18.7052 11.2611C20.1252 9.76109 20.7652 8.05109 18.5552 5.96109C16.3552 3.89109 14.6852 4.62109 13.2652 6.12109Z" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.8965 7.57068C12.3265 10.3307 14.5665 12.4407 17.3465 12.7207" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

